import { Award, MapPin } from "lucide-react";
import { BATTERY_BRANDS, buildWhatsAppLink } from "@/data/site";

export default function BrandShowcaseSection() {
  return (
    <section
      className="relative py-24 overflow-hidden"
      data-testid="what-we-do-section"
    >
      <div className="absolute inset-0 spotlight-gold opacity-30" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Biz Ne Yapıyoruz
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold leading-[1.05] text-balance">
            <span className="text-gradient-silver">Akü satışı, montaj </span>
            <span className="text-gradient-gold">ve yerinde hizmet.</span>
          </h2>
          <p className="mt-5 text-white/70 leading-relaxed">
            Star Otogaz olarak{" "}
            <span className="text-gold font-semibold">İnci Akü</span>,{" "}
            <span className="text-gold font-semibold">Varta</span> ve{" "}
            <span className="text-gold font-semibold">Bosch</span> marka
            akülerin satış ve montajını gerçekleştiriyoruz. Araç elektrik
            sistemi kontrolleri uzman ekibimiz tarafından yapılır.
          </p>
        </div>

        {/* Brand product cards - clean, no description */}
        <div className="grid sm:grid-cols-3 gap-6 mb-14">
          {BATTERY_BRANDS.map((b) => (
            <div
              key={b.name}
              data-testid={`brand-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative rounded-2xl overflow-hidden glass card-lift hover:border-gold/40"
              style={{ boxShadow: `inset 0 0 0 1px ${b.color}22` }}
            >
              <div
                className="absolute -top-px left-6 right-6 h-px opacity-0 group-hover:opacity-100 transition-opacity"
                style={{
                  background: `linear-gradient(90deg, transparent, ${b.color}, transparent)`,
                }}
              />

              {/* Product photo on white background */}
              <div className="relative aspect-[4/3] bg-white flex items-center justify-center p-6 overflow-hidden">
                <img
                  src={b.product}
                  alt={`${b.name} akü`}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-105"
                />
                {/* Authorized badge */}
                <div className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-gold text-black text-[9px] uppercase tracking-[0.18em] font-bold shadow-lg">
                  <Award className="w-3 h-3" />
                  Yetkili
                </div>
              </div>

              {/* Brand name strip */}
              <div className="relative px-5 py-4 bg-black border-t border-white/5 flex items-center justify-between">
                <div>
                  <div
                    className="font-display text-xl font-extrabold leading-none"
                    style={{ color: b.color }}
                  >
                    {b.name}
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.22em] text-white/55 mt-1 font-semibold">
                    {b.tagline}
                  </div>
                </div>
                <span
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: b.color }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* On-site service banner */}
        <div className="rounded-2xl glass-strong p-7 sm:p-9 grid lg:grid-cols-[1fr_auto] gap-6 items-center">
          <div className="flex items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-[#25D366]/15 border border-[#25D366]/40 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-6 h-6 text-[#25D366]" />
            </div>
            <div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-2">
                Yerinde Akü Değişim Hizmeti
              </h3>
              <p className="text-white/70 text-sm leading-relaxed">
                <span className="text-gold font-semibold">Ücretli</span>{" "}
                yerinde montaj hizmetimiz mevcuttur (servis ücreti vardır).
                WhatsApp üzerinden konumunuzu gönderin —{" "}
                <span className="text-white font-semibold">Eskişehir</span>'de
                bulunduğunuz adrese gelip akü değişiminizi yapalım.
              </p>
            </div>
          </div>
          <a
            href={buildWhatsAppLink(
              "Merhaba, bulunduğum adrese yerinde akü değişim hizmeti almak istiyorum. Konumumu paylaşıyorum."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="onsite-service-cta"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebd5a] text-white font-semibold px-7 py-3.5 transition-all justify-center"
          >
            <MapPin className="w-4 h-4" /> WhatsApp ile Konum Gönder
          </a>
        </div>
      </div>
    </section>
  );
}
